<template>
  <div class="pdt-20px">
    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <header class="header-card">
            <p>
              {{ $t('thirdStepUtilisateur.title')}}
            </p>
          </header>
          <div class="card-content">
            <div class="column">
              <b-field :label="$t('thirdStepUtilisateur.sousTitle')">
                <qd-taginput v-model="infoUser.objetsRoles"
                            :data="filteredTags"
                            type="is-primary"
                            autocomplete
                            open-on-focus
                            :placeholder="$t('thirdStepUtilisateur.placeholder')"
                            field="displayName"
                            @typing="getFilteredTags"
                            @input="initializeUserPermissions()"
                >
                  <template slot-scope="props">
                    {{ props.option.displayName }}
                  </template>
                  <template slot="empty">
                    {{ $t('thirdStepUtilisateur.noResult') }}
                  </template>
                </qd-taginput>
              </b-field>
            </div>
            <app-role-manager :allPermission="allPermissions"
                              :disable="true">
            </app-role-manager>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import messageErreur from '@/services/general/messageErreur';
import { getAllPermissions, getAll } from '@/api/role/index';
import AppRoleManager from '@/components/role/roleManager';
import { MODULES, DROITS } from '@/configuration/role/roleManagerConf';
import generationTableauDesRoles from '@/services/role/generationTableauDesRoles';
import getPermissionsWithRoles from '@/services/role/getPermissionsWithRoles';
import getRolesUtilisateur from '@/services/role/getRolesUtilisateur';
import mergePermission from '@/services/role/mergePermission';

export default {
  props: {
    infoUser: Object,
  },
  components: {
    AppRoleManager,
  },
  data() {
    return {
      filteredTags: [],
      allPermissions: [],
      userPermission: [],
      allRoles: [],
      allPermissionsExisting: [],
    };
  },
  methods: {
    getFilteredTags(text) {
      this.filteredTags = this.allRoles.filter((role) => {
        return role.displayName.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
          && (this.infoUser.objetsRoles === undefined
            || !this.infoUser.objetsRoles.includes(role));
      });
    },
    async initializeUserPermissions() {
      this.userPermission = await getPermissionsWithRoles(this.infoUser.objetsRoles);
      this.allPermissions = await generationTableauDesRoles(
        this.allPermissionsExisting,
        MODULES,
        DROITS,
      );
      this.allPermissions = mergePermission(
        this.allPermissions,
        this.userPermission,
      );
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.allPermissionsExisting = (await getAllPermissions()).data.result.items;
      this.infoUser.objetsRoles = await getRolesUtilisateur(this.infoUser.roles);
      this.initializeUserPermissions();
      this.allRoles = (await getAll()).data.result.items;
      this.allRoles.forEach((role) => {
        this.filteredTags.push(role);
      });
      this.allPermissions = mergePermission(
        this.allPermissions,
        this.userPermission,
      );
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
